import {
  BlockStack,
  Text,
  SkeletonBodyText,
  InlineStack,
} from "@medentic/polaris-react";
import { useTranslation } from "react-i18next";
import { AttendeeDetail } from "@features/events/types";
import { RenderDate } from "@shared/ui";
import { EVENT_CURRENCY_DEFAULT } from "@features/events/constants";
import { Currency } from "@shared/ui";

interface SummaryCardProps {
  attendee?: Partial<AttendeeDetail>;
  loading: boolean;
}

export default function SummaryCard({ attendee, loading }: SummaryCardProps) {
  const { t } = useTranslation();

  if (loading) {
    return <SkeletonBodyText lines={3} />;
  }

  return (
    <BlockStack gap="400">
      <Text variant="headingMd" as="h2">
        {t("attendeeDetails.summary.title")}
      </Text>

      <BlockStack gap="300">
        <InlineStack align="space-between">
          <Text variant="bodyMd" as="p">
            {t("attendeeDetails.summary.totalSpent")}
          </Text>
          <Text variant="bodyMd" as="p">
            <Currency
              value={attendee?.paymentsTotalSpent || 0}
              currency={EVENT_CURRENCY_DEFAULT}
            />
          </Text>
        </InlineStack>
        <InlineStack align="space-between">
          <Text variant="bodyMd" as="p">
            {t("attendeeDetails.summary.totalEventsAttended")}
          </Text>
          <Text variant="bodyMd" as="p">
            {attendee?.totalVisitedEvents || 0}
          </Text>
        </InlineStack>
        <InlineStack align="space-between">
          <Text variant="bodyMd" as="p">
            {t("attendeeDetails.summary.source")}
          </Text>
          <Text variant="bodyMd" as="p">
            {attendee?.source || "-"}
          </Text>
        </InlineStack>

        <InlineStack align="space-between">
          <Text variant="bodyMd" as="p">
            {t("attendeeDetails.summary.createdAt")}
          </Text>
          <Text variant="bodyMd" as="p">
            {attendee?.createdAt ? (
              <RenderDate dayFirst={true} date={attendee.createdAt} />
            ) : (
              "-"
            )}
          </Text>
        </InlineStack>

        <InlineStack align="space-between">
          <Text variant="bodyMd" as="p">
            {t("attendeeDetails.summary.updatedAt")}
          </Text>
          <Text variant="bodyMd" as="p">
            {attendee?.updatedAt ? (
              <RenderDate dayFirst={true} date={attendee.updatedAt} />
            ) : (
              "-"
            )}
          </Text>
        </InlineStack>
      </BlockStack>
    </BlockStack>
  );
}
